module.exports = __webpack_public_path__ + "img/amburger_yes.c0550ed0.png";